import controller from './chart.controller';
import template from './chart.html';

export default {
    controller,
    template,
    bindings: {
        xlabel: '<',
        ylabel: '<',
        data: '<',
        xlabels: '<',
        title: '<',
        height: '<',
        excludedItems: '<',
        onLegendItemToggle: '<'
    }
};


// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/chart/chart.component.js